import { ContentWithAside } from "layouts/kiosk-h"
import { EMDepartmentStoreKioskPage } from "./pages/em-department-store/index.kiosk"
import { themeOptionFactories } from "./theme"
import { EMDepartmentStoreMobilePage } from "./pages/em-department-store"
import { EMDepartmentStoreKioskOccupantsPage } from "./pages/em-department-store/[departId]/index.kiosk"
import { EMDepartmentStoreMobileOccupantPage } from "./pages/em-department-store/[departId]"

export const emDepartmentStore = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "department-store",
        element: <EMDepartmentStoreMobilePage />,
      },
      {
        path: "department-store/:departId/occupants",
        element: <EMDepartmentStoreMobileOccupantPage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "department-store",
        element: <EMDepartmentStoreKioskPage Layout={ContentWithAside} />,
      },
      {
        path: "department-store/:departId/occupants",
        element: (
          <EMDepartmentStoreKioskOccupantsPage Layout={ContentWithAside} />
        ),
      },
    ],
  },
}
